import { VueReCaptcha } from 'vue-recaptcha-v3';

function isUnsupportedBrowser() {
    const ua = window.navigator.userAgent;
    return /MSIE|Trident/.test(ua) || ua.includes('WebBrowser');
}

export default {
    install(Vue) {
        if (isUnsupportedBrowser()) {
            return;
        }

        Vue.use(VueReCaptcha, {
            siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            loaderOptions: {
                autoHideBadge: true,
                explicitRenderParameters: {
                    badge: 'bottomright',
                },
            },
        });
    },
};
